import GameObject from '../../GameObject/GameObject';
import Container from '../Container';
import Point from '../../Utility/Point';
import Sprite from '../Sprite';
import AnimationComponent from '../../Component/Animation';

export default class Arrow extends Container {
    public onCreate(params: any): void {
        super.onCreate(params);

        const arrowSprite = GameObject.Instantiate(Sprite, {
            ...params,
            texture: params.texture || 'ftux_arrow',
            anchor: new Point(0.5, 0.5),
        });
        arrowSprite.addComponent(AnimationComponent, {
            playOnStart: true,
            clipName: 'ArrowBounceLoop',
            ...params,
        });

        this.addChild(arrowSprite);
    }
}
